/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    DefaultJobDTO,
    DeleteRequestJobsByJobUuidParams,
    DeleteRequestJobsCoverByJobUuidParams,
    DeleteRequestJobsFilesByIdByJobUuidAndFileUuid200,
    DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    DeleteRequestProfilePictureParams,
    FileUUIDRollbackListDTO,
    GetRequestCoverAlbumParams,
    GetRequestJobs200Item,
    GetRequestJobsDefaultParams,
    GetRequestJobsInfoByJobUuid200,
    GetRequestJobsInfoByJobUuidParams,
    GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    GetRequestJobsLightParams,
    GetRequestJobsParams,
    GetRequestJobsTimelineDaysByJobUuidParams,
    GetRequestJobsTimelineMonthsByJobUuidParams,
    GetRequestJobsUsersByJobUuidParams,
    GetRequestProfileAlbumParams,
    GetRequestProfilePictureParams,
    HTTPValidationErrorDTO,
    InstantDTO,
    JobListLightDTO,
    JobServiceRespDTO,
    JobUUIDListDTO,
    KeepFilesQuotaExceededDTO,
    MessageAndResultResponseDTO,
    MessageResponseDTO,
    PictureJobResponseDTO,
    PostRequestJobsCoverByJobUuidParams,
    PostRequestJobsDeleteByJobUuidParams,
    PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuid200,
    PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams,
    PostRequestJobsKeepAllFilesByJobUuidParams,
    PostRequestJobsKeepFilesByJobUuid200,
    PostRequestJobsKeepFilesByJobUuidParams,
    PostRequestJobsMultiRollbackByJobUuidParams,
    PostRequestJobsNameByJobUuidParams,
    PostRequestJobsParams,
    PostRequestJobsRollbackByJobUuidParams,
    PostRequestJobsRollbackJobByJobUuidParams,
    PostRequestJobsSubscribeByJobUuidParams,
    PostRequestJobsUnsubscribeByJobUuidParams,
    PostRequestProfilePictureBodiesTwo,
    PostRequestProfilePictureParams,
    PostRequestRollbackAlbumsParams,
    ProfilePictureUploadResponseDTO,
    PutRequestJobsAttributeByJobUuidAndAttributeParams,
    PutRequestJobsByJobUuidParams,
    RestoreAlbumsResponseDTO,
    RollbackMultiResponseDTO,
    SetJobDataResponseDTO,
    TimelineDaysDTO,
    TimelineMonthsDTO,
    UsageAndQuotaResponseDTO,
    UsersResponseDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * This is the method to create a new job.
If the job is of type story,
it is possible to specify the permission settings

 * @summary Post Job
 */
export const postRequestJobs = (
    params: PostRequestJobsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SetJobDataResponseDTO>(
        { url: `/jobs`, method: 'POST', params, signal },
        options,
    )
}

export const getPostRequestJobsMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobs>>,
        TError,
        { params: PostRequestJobsParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobs>>,
    TError,
    { params: PostRequestJobsParams },
    TContext
> => {
    const mutationKey = ['postRequestJobs']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobs>>,
        { params: PostRequestJobsParams }
    > = (props) => {
        const { params } = props ?? {}

        return postRequestJobs(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobs>>
>

export type PostRequestJobsMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Job
 */
export const usePostRequestJobs = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobs>>,
            TError,
            { params: PostRequestJobsParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobs>>,
    TError,
    { params: PostRequestJobsParams },
    TContext
> => {
    const mutationOptions = getPostRequestJobsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * The list of all jobs, shares, albums owned or shared with the user. Timeline jobs and shares
are of the type `JobResponse`, albums, cover and profile jobs are of the type
`JobListStoryResponse`. If `include_details` is `True`, albums will be of this type
 * @summary Get Job List
 */
export const getRequestJobs = (
    params: GetRequestJobsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GetRequestJobs200Item[]>(
        { url: `/jobs`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestJobsQueryKey = (params?: GetRequestJobsParams) => {
    return [`/jobs`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobs>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobs>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestJobsQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobs>>
    > = ({ signal }) => getRequestJobs(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobs>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobs>>
>
export type GetRequestJobsQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobs<
    TData = Awaited<ReturnType<typeof getRequestJobs>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobs>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobs>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobs>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobs<
    TData = Awaited<ReturnType<typeof getRequestJobs>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobs>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobs>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobs>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobs<
    TData = Awaited<ReturnType<typeof getRequestJobs>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobs>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Job List
 */

export function useGetRequestJobs<
    TData = Awaited<ReturnType<typeof getRequestJobs>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobs>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * A lighter version of the job list, only containing the job id, serial and last update time
for each job. Also includes the feature flag hash and the max and used space for the user.
 * @summary Get Job List Light
 */
export const getRequestJobsLight = (
    params: GetRequestJobsLightParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<JobListLightDTO>(
        { url: `/jobs_light`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestJobsLightQueryKey = (
    params?: GetRequestJobsLightParams,
) => {
    return [`/jobs_light`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsLightQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsLight>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsLightParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsLight>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestJobsLightQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsLight>>
    > = ({ signal }) => getRequestJobsLight(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsLight>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsLightQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsLight>>
>
export type GetRequestJobsLightQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsLight<
    TData = Awaited<ReturnType<typeof getRequestJobsLight>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsLightParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsLight>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsLight>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsLight>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsLight<
    TData = Awaited<ReturnType<typeof getRequestJobsLight>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsLightParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsLight>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsLight>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsLight>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsLight<
    TData = Awaited<ReturnType<typeof getRequestJobsLight>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsLightParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsLight>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Job List Light
 */

export function useGetRequestJobsLight<
    TData = Awaited<ReturnType<typeof getRequestJobsLight>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsLightParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsLight>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsLightQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Returns information on a specific job
 * @summary Get Job Info
 */
export const getRequestJobsInfoByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsInfoByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GetRequestJobsInfoByJobUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/info`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsInfoByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsInfoByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/info`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsInfoByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsInfoByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsInfoByJobUuid(jobUuid, params, requestOptions, signal)

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsInfoByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>
>
export type GetRequestJobsInfoByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsInfoByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Job Info
 */

export function useGetRequestJobsInfoByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsInfoByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsInfoByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsInfoByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This api call returns the service for the job_uuid.
Note that the poll-host might be different for https (see description)

 * @summary Job Service Get Handler
 */
export const getRequestJobsServiceByJobUuid = (
    jobUuid: string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<JobServiceRespDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/service`,
            method: 'GET',
            signal,
        },
        options,
    )
}

export const getGetRequestJobsServiceByJobUuidQueryKey = (jobUuid?: string) => {
    return [`/jobs/${jobUuid}/service`] as const
}

export const getGetRequestJobsServiceByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsServiceByJobUuidQueryKey(jobUuid)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsServiceByJobUuid(jobUuid, requestOptions, signal)

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsServiceByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>
>
export type GetRequestJobsServiceByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsServiceByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsServiceByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsServiceByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Job Service Get Handler
 */

export function useGetRequestJobsServiceByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsServiceByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsServiceByJobUuidQueryOptions(
        jobUuid,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Returns users that are subscribers, or have previously been subscribers to an album
 * @summary Get Album Users
 */
export const getRequestJobsUsersByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsUsersByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<UsersResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/users`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsUsersByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsUsersByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/users`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsUsersByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsUsersByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsUsersByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsUsersByJobUuid(jobUuid, params, requestOptions, signal)

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsUsersByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>
>
export type GetRequestJobsUsersByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsUsersByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsUsersByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsUsersByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsUsersByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsUsersByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsUsersByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Album Users
 */

export function useGetRequestJobsUsersByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsUsersByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsUsersByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsUsersByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This api call returns the amount of images per day in the timeline.

 * @summary Timeline Days
 */
export const getRequestJobsTimelineDaysByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsTimelineDaysByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<TimelineDaysDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/timeline/days`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsTimelineDaysByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsTimelineDaysByJobUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/timeline/days`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsTimelineDaysByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineDaysByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsTimelineDaysByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsTimelineDaysByJobUuid(
            jobUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsTimelineDaysByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>
>
export type GetRequestJobsTimelineDaysByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsTimelineDaysByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineDaysByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsTimelineDaysByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineDaysByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsTimelineDaysByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineDaysByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Timeline Days
 */

export function useGetRequestJobsTimelineDaysByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineDaysByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsTimelineDaysByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsTimelineDaysByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This api call returns the amount of images per months in the timeline.

 * @summary Timeline Months
 */
export const getRequestJobsTimelineMonthsByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsTimelineMonthsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<TimelineMonthsDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/timeline/months`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsTimelineMonthsByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsTimelineMonthsByJobUuidParams,
) => {
    return [
        `/jobs/${jobUuid}/timeline/months`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsTimelineMonthsByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineMonthsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsTimelineMonthsByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>
    > = ({ signal }) =>
        getRequestJobsTimelineMonthsByJobUuid(
            jobUuid,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsTimelineMonthsByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>
>
export type GetRequestJobsTimelineMonthsByJobUuidQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsTimelineMonthsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineMonthsByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsTimelineMonthsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineMonthsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsTimelineMonthsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineMonthsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Timeline Months
 */

export function useGetRequestJobsTimelineMonthsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsTimelineMonthsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getRequestJobsTimelineMonthsByJobUuid>
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsTimelineMonthsByJobUuidQueryOptions(
        jobUuid,
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Add an attribute to a job. If attributes for a job is set, it will be part of the job object

 * @summary Put Attribute On Job
 */
export const putRequestJobsAttributeByJobUuidAndAttribute = (
    jobUuid: string,
    attribute: string,
    params: PutRequestJobsAttributeByJobUuidAndAttributeParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown | void>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/attribute/${encodeURIComponent(String(attribute))}`,
            method: 'PUT',
            params,
        },
        options,
    )
}

export const getPutRequestJobsAttributeByJobUuidAndAttributeMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<typeof putRequestJobsAttributeByJobUuidAndAttribute>
        >,
        TError,
        {
            jobUuid: string
            attribute: string
            params: PutRequestJobsAttributeByJobUuidAndAttributeParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof putRequestJobsAttributeByJobUuidAndAttribute>>,
    TError,
    {
        jobUuid: string
        attribute: string
        params: PutRequestJobsAttributeByJobUuidAndAttributeParams
    },
    TContext
> => {
    const mutationKey = ['putRequestJobsAttributeByJobUuidAndAttribute']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<typeof putRequestJobsAttributeByJobUuidAndAttribute>
        >,
        {
            jobUuid: string
            attribute: string
            params: PutRequestJobsAttributeByJobUuidAndAttributeParams
        }
    > = (props) => {
        const { jobUuid, attribute, params } = props ?? {}

        return putRequestJobsAttributeByJobUuidAndAttribute(
            jobUuid,
            attribute,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PutRequestJobsAttributeByJobUuidAndAttributeMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof putRequestJobsAttributeByJobUuidAndAttribute>>
    >

export type PutRequestJobsAttributeByJobUuidAndAttributeMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Put Attribute On Job
 */
export const usePutRequestJobsAttributeByJobUuidAndAttribute = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof putRequestJobsAttributeByJobUuidAndAttribute>
            >,
            TError,
            {
                jobUuid: string
                attribute: string
                params: PutRequestJobsAttributeByJobUuidAndAttributeParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof putRequestJobsAttributeByJobUuidAndAttribute>>,
    TError,
    {
        jobUuid: string
        attribute: string
        params: PutRequestJobsAttributeByJobUuidAndAttributeParams
    },
    TContext
> => {
    const mutationOptions =
        getPutRequestJobsAttributeByJobUuidAndAttributeMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call archive the files for a job
 * @summary Delete File Delete
 */
export const deleteRequestJobsFilesByIdByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<DeleteRequestJobsFilesByIdByJobUuidAndFileUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}`,
            method: 'DELETE',
            params,
        },
        options,
    )
}

export const getDeleteRequestJobsFilesByIdByJobUuidAndFileUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<typeof deleteRequestJobsFilesByIdByJobUuidAndFileUuid>
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            params: DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams
        },
        TContext
    > => {
        const mutationKey = ['deleteRequestJobsFilesByIdByJobUuidAndFileUuid']
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdByJobUuidAndFileUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                params: DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, params } = props ?? {}

            return deleteRequestJobsFilesByIdByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type DeleteRequestJobsFilesByIdByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<typeof deleteRequestJobsFilesByIdByJobUuidAndFileUuid>
        >
    >

export type DeleteRequestJobsFilesByIdByJobUuidAndFileUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete File Delete
 */
export const useDeleteRequestJobsFilesByIdByJobUuidAndFileUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestJobsFilesByIdByJobUuidAndFileUuid>>,
    TError,
    {
        jobUuid: string
        fileUuid: string
        params: DeleteRequestJobsFilesByIdByJobUuidAndFileUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestJobsFilesByIdByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * This method is used to update the job title and password

 * @summary Put Job
 */
export const putRequestJobsByJobUuid = (
    jobUuid: string,
    params: PutRequestJobsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<SetJobDataResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}`,
            method: 'PUT',
            params,
        },
        options,
    )
}

export const getPutRequestJobsByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putRequestJobsByJobUuid>>,
        TError,
        { jobUuid: string; params: PutRequestJobsByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof putRequestJobsByJobUuid>>,
    TError,
    { jobUuid: string; params: PutRequestJobsByJobUuidParams },
    TContext
> => {
    const mutationKey = ['putRequestJobsByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putRequestJobsByJobUuid>>,
        { jobUuid: string; params: PutRequestJobsByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return putRequestJobsByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PutRequestJobsByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof putRequestJobsByJobUuid>>
>

export type PutRequestJobsByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Put Job
 */
export const usePutRequestJobsByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putRequestJobsByJobUuid>>,
            TError,
            { jobUuid: string; params: PutRequestJobsByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof putRequestJobsByJobUuid>>,
    TError,
    { jobUuid: string; params: PutRequestJobsByJobUuidParams },
    TContext
> => {
    const mutationOptions = getPutRequestJobsByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Delete a job

 * @summary Delete Job Delete
 */
export const deleteRequestJobsByJobUuid = (
    jobUuid: string,
    params: DeleteRequestJobsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}`,
            method: 'DELETE',
            params,
        },
        options,
    )
}

export const getDeleteRequestJobsByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestJobsByJobUuid>>,
        TError,
        { jobUuid: string; params: DeleteRequestJobsByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestJobsByJobUuid>>,
    TError,
    { jobUuid: string; params: DeleteRequestJobsByJobUuidParams },
    TContext
> => {
    const mutationKey = ['deleteRequestJobsByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestJobsByJobUuid>>,
        { jobUuid: string; params: DeleteRequestJobsByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return deleteRequestJobsByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestJobsByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestJobsByJobUuid>>
>

export type DeleteRequestJobsByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Job Delete
 */
export const useDeleteRequestJobsByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestJobsByJobUuid>>,
            TError,
            { jobUuid: string; params: DeleteRequestJobsByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestJobsByJobUuid>>,
    TError,
    { jobUuid: string; params: DeleteRequestJobsByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestJobsByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Returns the default job for a user,
if the default job does not exists it will be created

 * @summary Get Default Job
 */
export const getRequestJobsDefault = (
    params: GetRequestJobsDefaultParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<DefaultJobDTO>(
        { url: `/jobs/default`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestJobsDefaultQueryKey = (
    params?: GetRequestJobsDefaultParams,
) => {
    return [`/jobs/default`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsDefaultQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsDefault>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsDefaultParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsDefault>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestJobsDefaultQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsDefault>>
    > = ({ signal }) => getRequestJobsDefault(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsDefault>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsDefaultQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsDefault>>
>
export type GetRequestJobsDefaultQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestJobsDefault<
    TData = Awaited<ReturnType<typeof getRequestJobsDefault>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsDefaultParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsDefault>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsDefault>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsDefault>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsDefault<
    TData = Awaited<ReturnType<typeof getRequestJobsDefault>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsDefaultParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsDefault>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsDefault>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsDefault>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsDefault<
    TData = Awaited<ReturnType<typeof getRequestJobsDefault>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsDefaultParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsDefault>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Default Job
 */

export function useGetRequestJobsDefault<
    TData = Awaited<ReturnType<typeof getRequestJobsDefault>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestJobsDefaultParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsDefault>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestJobsDefaultQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * add story subscription

 * @summary Subscribe To Story
 */
export const postRequestJobsSubscribeByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsSubscribeByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/subscribe`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsSubscribeByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsSubscribeByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsSubscribeByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsSubscribeByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsSubscribeByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsSubscribeByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsSubscribeByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsSubscribeByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsSubscribeByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsSubscribeByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsSubscribeByJobUuid>>
>

export type PostRequestJobsSubscribeByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Subscribe To Story
 */
export const usePostRequestJobsSubscribeByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsSubscribeByJobUuid>>,
            TError,
            {
                jobUuid: string
                params: PostRequestJobsSubscribeByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsSubscribeByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsSubscribeByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsSubscribeByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * unsubscription

 * @summary Unsubscribe To Story
 */
export const postRequestJobsUnsubscribeByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsUnsubscribeByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/unsubscribe`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsUnsubscribeByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsUnsubscribeByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsUnsubscribeByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsUnsubscribeByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsUnsubscribeByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsUnsubscribeByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsUnsubscribeByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsUnsubscribeByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsUnsubscribeByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsUnsubscribeByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsUnsubscribeByJobUuid>>
>

export type PostRequestJobsUnsubscribeByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Unsubscribe To Story
 */
export const usePostRequestJobsUnsubscribeByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsUnsubscribeByJobUuid>>,
            TError,
            {
                jobUuid: string
                params: PostRequestJobsUnsubscribeByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsUnsubscribeByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsUnsubscribeByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsUnsubscribeByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Returns the profile job for a user,
if the  profile job does not exists it will be created

 * @summary Get Profile Album
 */
export const getRequestProfileAlbum = (
    params: GetRequestProfileAlbumParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PictureJobResponseDTO>(
        { url: `/profile_album`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestProfileAlbumQueryKey = (
    params?: GetRequestProfileAlbumParams,
) => {
    return [`/profile_album`, ...(params ? [params] : [])] as const
}

export const getGetRequestProfileAlbumQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestProfileAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestProfileAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestProfileAlbumQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestProfileAlbum>>
    > = ({ signal }) => getRequestProfileAlbum(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestProfileAlbum>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestProfileAlbumQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestProfileAlbum>>
>
export type GetRequestProfileAlbumQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestProfileAlbum<
    TData = Awaited<ReturnType<typeof getRequestProfileAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestProfileAlbumParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestProfileAlbum>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestProfileAlbum<
    TData = Awaited<ReturnType<typeof getRequestProfileAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestProfileAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestProfileAlbum>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestProfileAlbum<
    TData = Awaited<ReturnType<typeof getRequestProfileAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestProfileAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Profile Album
 */

export function useGetRequestProfileAlbum<
    TData = Awaited<ReturnType<typeof getRequestProfileAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestProfileAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfileAlbum>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestProfileAlbumQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Returns the cover job for a user,
if the cover job does not exists it will be created

 * @summary Get Cover Album
 */
export const getRequestCoverAlbum = (
    params: GetRequestCoverAlbumParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PictureJobResponseDTO>(
        { url: `/cover_album`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestCoverAlbumQueryKey = (
    params?: GetRequestCoverAlbumParams,
) => {
    return [`/cover_album`, ...(params ? [params] : [])] as const
}

export const getGetRequestCoverAlbumQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestCoverAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCoverAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestCoverAlbumQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestCoverAlbum>>
    > = ({ signal }) => getRequestCoverAlbum(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestCoverAlbum>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestCoverAlbumQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestCoverAlbum>>
>
export type GetRequestCoverAlbumQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestCoverAlbum<
    TData = Awaited<ReturnType<typeof getRequestCoverAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCoverAlbumParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestCoverAlbum>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestCoverAlbum<
    TData = Awaited<ReturnType<typeof getRequestCoverAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCoverAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestCoverAlbum>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestCoverAlbum<
    TData = Awaited<ReturnType<typeof getRequestCoverAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCoverAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Cover Album
 */

export function useGetRequestCoverAlbum<
    TData = Awaited<ReturnType<typeof getRequestCoverAlbum>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestCoverAlbumParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestCoverAlbum>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestCoverAlbumQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call is there to upload the new profile picture.
Only the user can change his or her profile picture.
If no content is provided in the body, we assume dedup.
In the case of dedup, the checksum must be provided

 * @summary Post Profile Picture
 */
export const postRequestProfilePicture = (
    postRequestProfilePictureBodiesTwo: BodyType<PostRequestProfilePictureBodiesTwo>,
    params: PostRequestProfilePictureParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    const formData = new FormData()
    if (postRequestProfilePictureBodiesTwo.file !== undefined) {
        formData.append(`file`, postRequestProfilePictureBodiesTwo.file)
    }

    return customInstance<void | ProfilePictureUploadResponseDTO>(
        {
            url: `/profile/picture`,
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestProfilePictureMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestProfilePicture>>,
        TError,
        {
            data: BodyType<PostRequestProfilePictureBodiesTwo>
            params: PostRequestProfilePictureParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestProfilePicture>>,
    TError,
    {
        data: BodyType<PostRequestProfilePictureBodiesTwo>
        params: PostRequestProfilePictureParams
    },
    TContext
> => {
    const mutationKey = ['postRequestProfilePicture']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestProfilePicture>>,
        {
            data: BodyType<PostRequestProfilePictureBodiesTwo>
            params: PostRequestProfilePictureParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestProfilePicture(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestProfilePictureMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestProfilePicture>>
>
export type PostRequestProfilePictureMutationBody =
    BodyType<PostRequestProfilePictureBodiesTwo>
export type PostRequestProfilePictureMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Profile Picture
 */
export const usePostRequestProfilePicture = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestProfilePicture>>,
            TError,
            {
                data: BodyType<PostRequestProfilePictureBodiesTwo>
                params: PostRequestProfilePictureParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestProfilePicture>>,
    TError,
    {
        data: BodyType<PostRequestProfilePictureBodiesTwo>
        params: PostRequestProfilePictureParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestProfilePictureMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call gets the full size version of the profile picture.
Only the owner can access the full size profile image

 * @summary Get Profile Picture
 */
export const getRequestProfilePicture = (
    params: GetRequestProfilePictureParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<Blob>(
        {
            url: `/profile/picture`,
            method: 'GET',
            params,
            responseType: 'blob',
            signal,
        },
        options,
    )
}

export const getGetRequestProfilePictureQueryKey = (
    params?: GetRequestProfilePictureParams,
) => {
    return [`/profile/picture`, ...(params ? [params] : [])] as const
}

export const getGetRequestProfilePictureQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestProfilePicture>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestProfilePictureParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfilePicture>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestProfilePictureQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestProfilePicture>>
    > = ({ signal }) => getRequestProfilePicture(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestProfilePicture>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestProfilePictureQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestProfilePicture>>
>
export type GetRequestProfilePictureQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestProfilePicture<
    TData = Awaited<ReturnType<typeof getRequestProfilePicture>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestProfilePictureParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfilePicture>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestProfilePicture>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestProfilePicture>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestProfilePicture<
    TData = Awaited<ReturnType<typeof getRequestProfilePicture>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestProfilePictureParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfilePicture>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestProfilePicture>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestProfilePicture>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestProfilePicture<
    TData = Awaited<ReturnType<typeof getRequestProfilePicture>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestProfilePictureParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfilePicture>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Profile Picture
 */

export function useGetRequestProfilePicture<
    TData = Awaited<ReturnType<typeof getRequestProfilePicture>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    params: GetRequestProfilePictureParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestProfilePicture>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestProfilePictureQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * This call removes the profile picture of the user

 * @summary Delete Profile Picture
 */
export const deleteRequestProfilePicture = (
    params: DeleteRequestProfilePictureParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<MessageAndResultResponseDTO>(
        { url: `/profile/picture`, method: 'DELETE', params },
        options,
    )
}

export const getDeleteRequestProfilePictureMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestProfilePicture>>,
        TError,
        { params: DeleteRequestProfilePictureParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestProfilePicture>>,
    TError,
    { params: DeleteRequestProfilePictureParams },
    TContext
> => {
    const mutationKey = ['deleteRequestProfilePicture']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestProfilePicture>>,
        { params: DeleteRequestProfilePictureParams }
    > = (props) => {
        const { params } = props ?? {}

        return deleteRequestProfilePicture(params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestProfilePictureMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestProfilePicture>>
>

export type DeleteRequestProfilePictureMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Profile Picture
 */
export const useDeleteRequestProfilePicture = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestProfilePicture>>,
            TError,
            { params: DeleteRequestProfilePictureParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestProfilePicture>>,
    TError,
    { params: DeleteRequestProfilePictureParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestProfilePictureMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to restore a deleted album

 * @summary Rollback Album
 */
export const postRequestJobsRollbackJobByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsRollbackJobByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/rollback_job`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsRollbackJobByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsRollbackJobByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsRollbackJobByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsRollbackJobByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsRollbackJobByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsRollbackJobByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsRollbackJobByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsRollbackJobByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsRollbackJobByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsRollbackJobByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsRollbackJobByJobUuid>>
>

export type PostRequestJobsRollbackJobByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Rollback Album
 */
export const usePostRequestJobsRollbackJobByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsRollbackJobByJobUuid>>,
            TError,
            {
                jobUuid: string
                params: PostRequestJobsRollbackJobByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsRollbackJobByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsRollbackJobByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsRollbackJobByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to restore deleted albums

 * @summary Rollback Albums
 */
export const postRequestRollbackAlbums = (
    jobUUIDListDTO: BodyType<JobUUIDListDTO>,
    params: PostRequestRollbackAlbumsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<RestoreAlbumsResponseDTO>(
        {
            url: `/rollback_albums`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: jobUUIDListDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestRollbackAlbumsMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestRollbackAlbums>>,
        TError,
        {
            data: BodyType<JobUUIDListDTO>
            params: PostRequestRollbackAlbumsParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestRollbackAlbums>>,
    TError,
    { data: BodyType<JobUUIDListDTO>; params: PostRequestRollbackAlbumsParams },
    TContext
> => {
    const mutationKey = ['postRequestRollbackAlbums']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestRollbackAlbums>>,
        {
            data: BodyType<JobUUIDListDTO>
            params: PostRequestRollbackAlbumsParams
        }
    > = (props) => {
        const { data, params } = props ?? {}

        return postRequestRollbackAlbums(data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestRollbackAlbumsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestRollbackAlbums>>
>
export type PostRequestRollbackAlbumsMutationBody = BodyType<JobUUIDListDTO>
export type PostRequestRollbackAlbumsMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Rollback Albums
 */
export const usePostRequestRollbackAlbums = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestRollbackAlbums>>,
            TError,
            {
                data: BodyType<JobUUIDListDTO>
                params: PostRequestRollbackAlbumsParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestRollbackAlbums>>,
    TError,
    { data: BodyType<JobUUIDListDTO>; params: PostRequestRollbackAlbumsParams },
    TContext
> => {
    const mutationOptions = getPostRequestRollbackAlbumsMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Rollback Files
 */
export const postRequestJobsMultiRollbackByJobUuid = (
    jobUuid: string,
    fileUUIDRollbackListDTO: BodyType<FileUUIDRollbackListDTO>,
    params: PostRequestJobsMultiRollbackByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<RollbackMultiResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/multi_rollback`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: fileUUIDRollbackListDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsMultiRollbackByJobUuidMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsMultiRollbackByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<FileUUIDRollbackListDTO>
            params: PostRequestJobsMultiRollbackByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsMultiRollbackByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<FileUUIDRollbackListDTO>
        params: PostRequestJobsMultiRollbackByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsMultiRollbackByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsMultiRollbackByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<FileUUIDRollbackListDTO>
            params: PostRequestJobsMultiRollbackByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsMultiRollbackByJobUuid(
            jobUuid,
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsMultiRollbackByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsMultiRollbackByJobUuid>>
>
export type PostRequestJobsMultiRollbackByJobUuidMutationBody =
    BodyType<FileUUIDRollbackListDTO>
export type PostRequestJobsMultiRollbackByJobUuidMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Rollback Files
 */
export const usePostRequestJobsMultiRollbackByJobUuid = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsMultiRollbackByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<FileUUIDRollbackListDTO>
                params: PostRequestJobsMultiRollbackByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsMultiRollbackByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<FileUUIDRollbackListDTO>
        params: PostRequestJobsMultiRollbackByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsMultiRollbackByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Use /jobs/{job_uuid}/multi_rollback
 * @deprecated
 * @summary Rollback File
 */
export const postRequestJobsRollbackByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsRollbackByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<UsageAndQuotaResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/rollback`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsRollbackByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsRollbackByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsRollbackByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsRollbackByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsRollbackByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsRollbackByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsRollbackByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsRollbackByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsRollbackByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsRollbackByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsRollbackByJobUuid>>
>

export type PostRequestJobsRollbackByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @deprecated
 * @summary Rollback File
 */
export const usePostRequestJobsRollbackByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsRollbackByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsRollbackByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsRollbackByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsRollbackByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsRollbackByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call archives the files for a job
 * @deprecated
 * @summary Post File Delete
 */
export const postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/delete`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            params: PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, params } = props ?? {}

            return postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid
            >
        >
    >

export type PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @deprecated
 * @summary Post File Delete
 */
export const usePostRequestJobsFilesByIdDeleteByJobUuidAndFileUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<typeof postRequestJobsFilesByIdDeleteByJobUuidAndFileUuid>
    >,
    TError,
    {
        jobUuid: string
        fileUuid: string
        params: PostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesByIdDeleteByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * Delete a job

 * @deprecated
 * @summary Post Job Delete
 */
export const postRequestJobsDeleteByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsDeleteByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/delete`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsDeleteByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsDeleteByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsDeleteByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsDeleteByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsDeleteByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsDeleteByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsDeleteByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsDeleteByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsDeleteByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsDeleteByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsDeleteByJobUuid>>
>

export type PostRequestJobsDeleteByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @deprecated
 * @summary Post Job Delete
 */
export const usePostRequestJobsDeleteByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsDeleteByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsDeleteByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsDeleteByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsDeleteByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsDeleteByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call saves all the files from a story or share to a timeline.
Before attempting to keep any files, it will first check if the
user has sufficient storage space available to save all the files.
Note that it is possible to pass this initial test,
but still receive a 413 if files are added to the account in question
while this call is processed.

 * @summary Keep All Files
 */
export const postRequestJobsKeepAllFilesByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsKeepAllFilesByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/keep-all-files`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsKeepAllFilesByJobUuidMutationOptions = <
    TError = ErrorType<
        | void
        | MessageResponseDTO
        | KeepFilesQuotaExceededDTO
        | HTTPValidationErrorDTO
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsKeepAllFilesByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsKeepAllFilesByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsKeepAllFilesByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsKeepAllFilesByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsKeepAllFilesByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsKeepAllFilesByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsKeepAllFilesByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsKeepAllFilesByJobUuid(
            jobUuid,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsKeepAllFilesByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsKeepAllFilesByJobUuid>>
>

export type PostRequestJobsKeepAllFilesByJobUuidMutationError = ErrorType<
    | void
    | MessageResponseDTO
    | KeepFilesQuotaExceededDTO
    | HTTPValidationErrorDTO
>

/**
 * @summary Keep All Files
 */
export const usePostRequestJobsKeepAllFilesByJobUuid = <
    TError = ErrorType<
        | void
        | MessageResponseDTO
        | KeepFilesQuotaExceededDTO
        | HTTPValidationErrorDTO
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsKeepAllFilesByJobUuid>>,
            TError,
            {
                jobUuid: string
                params: PostRequestJobsKeepAllFilesByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsKeepAllFilesByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsKeepAllFilesByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsKeepAllFilesByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * This call keeps all specified files from a story or share to a timeline
Before attempting to keep any files, it will first check if the
user has sufficient storage space available to save all the files.
Note that it is possible to pass this initial test,
but still receive a 413, if files are added to the account in question
while this call is processed.
If any of the files specified is the master of a group,
all group members will be kept as well

 * @summary Keep Files
 */
export const postRequestJobsKeepFilesByJobUuid = (
    jobUuid: BodyType<string>,
    postRequestJobsKeepFilesByJobUuidBodies: string,
    params: PostRequestJobsKeepFilesByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<PostRequestJobsKeepFilesByJobUuid200>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/keep-files`,
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            data: postRequestJobsKeepFilesByJobUuidBodies,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsKeepFilesByJobUuidMutationOptions = <
    TError = ErrorType<
        | void
        | MessageResponseDTO
        | KeepFilesQuotaExceededDTO
        | HTTPValidationErrorDTO
    >,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsKeepFilesByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<string>
            params: PostRequestJobsKeepFilesByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsKeepFilesByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<string>
        params: PostRequestJobsKeepFilesByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsKeepFilesByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsKeepFilesByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<string>
            params: PostRequestJobsKeepFilesByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsKeepFilesByJobUuid(
            jobUuid,
            data,
            params,
            requestOptions,
        )
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsKeepFilesByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsKeepFilesByJobUuid>>
>
export type PostRequestJobsKeepFilesByJobUuidMutationBody = BodyType<string>
export type PostRequestJobsKeepFilesByJobUuidMutationError = ErrorType<
    | void
    | MessageResponseDTO
    | KeepFilesQuotaExceededDTO
    | HTTPValidationErrorDTO
>

/**
 * @summary Keep Files
 */
export const usePostRequestJobsKeepFilesByJobUuid = <
    TError = ErrorType<
        | void
        | MessageResponseDTO
        | KeepFilesQuotaExceededDTO
        | HTTPValidationErrorDTO
    >,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsKeepFilesByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<string>
                params: PostRequestJobsKeepFilesByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsKeepFilesByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<string>
        params: PostRequestJobsKeepFilesByJobUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsKeepFilesByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call sets the cover id on a story job

 * @summary Post Job Cover
 */
export const postRequestJobsCoverByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsCoverByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/cover`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsCoverByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsCoverByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsCoverByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsCoverByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsCoverByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsCoverByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsCoverByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsCoverByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsCoverByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsCoverByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsCoverByJobUuid>>
>

export type PostRequestJobsCoverByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Job Cover
 */
export const usePostRequestJobsCoverByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsCoverByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsCoverByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsCoverByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsCoverByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsCoverByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call deletes the cover id on a story job

 * @summary Delete Job Cover
 */
export const deleteRequestJobsCoverByJobUuid = (
    jobUuid: string,
    params: DeleteRequestJobsCoverByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/cover`,
            method: 'DELETE',
            params,
        },
        options,
    )
}

export const getDeleteRequestJobsCoverByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestJobsCoverByJobUuid>>,
        TError,
        { jobUuid: string; params: DeleteRequestJobsCoverByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestJobsCoverByJobUuid>>,
    TError,
    { jobUuid: string; params: DeleteRequestJobsCoverByJobUuidParams },
    TContext
> => {
    const mutationKey = ['deleteRequestJobsCoverByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestJobsCoverByJobUuid>>,
        { jobUuid: string; params: DeleteRequestJobsCoverByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return deleteRequestJobsCoverByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestJobsCoverByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestJobsCoverByJobUuid>>
>

export type DeleteRequestJobsCoverByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Job Cover
 */
export const useDeleteRequestJobsCoverByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestJobsCoverByJobUuid>>,
            TError,
            { jobUuid: string; params: DeleteRequestJobsCoverByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestJobsCoverByJobUuid>>,
    TError,
    { jobUuid: string; params: DeleteRequestJobsCoverByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getDeleteRequestJobsCoverByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to change the title for shared and story jobs.

 * @summary Post Job Name
 */
export const postRequestJobsNameByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsNameByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/name`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsNameByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsNameByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsNameByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsNameByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsNameByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsNameByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsNameByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsNameByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsNameByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsNameByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsNameByJobUuid>>
>

export type PostRequestJobsNameByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Job Name
 */
export const usePostRequestJobsNameByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsNameByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsNameByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsNameByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsNameByJobUuidParams },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsNameByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Metatags Inject
 */
export const getRequestMetatagsByJobUuid = (
    jobUuid: string | string,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/metatags/${encodeURIComponent(String(jobUuid))}`,
            method: 'GET',
            signal,
        },
        options,
    )
}

export const getGetRequestMetatagsByJobUuidQueryKey = (
    jobUuid?: string | string,
) => {
    return [`/metatags/${jobUuid}`] as const
}

export const getGetRequestMetatagsByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string | string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestMetatagsByJobUuidQueryKey(jobUuid)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>
    > = ({ signal }) =>
        getRequestMetatagsByJobUuid(jobUuid, requestOptions, signal)

    return {
        queryKey,
        queryFn,
        enabled: !!jobUuid,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestMetatagsByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>
>
export type GetRequestMetatagsByJobUuidQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestMetatagsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string | string,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestMetatagsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string | string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestMetatagsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string | string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Metatags Inject
 */

export function useGetRequestMetatagsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    jobUuid: string | string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestMetatagsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestMetatagsByJobUuidQueryOptions(
        jobUuid,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Get memories from a job for a date range

 * @summary Get Instant By Date
 */
export const getRequestJobsInstantsByJobUuidAndDateRange = (
    jobUuid: string,
    dateRange: string,
    params: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<InstantDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/instants/${encodeURIComponent(String(dateRange))}`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsInstantsByJobUuidAndDateRangeQueryKey = (
    jobUuid?: string,
    dateRange?: string,
    params?: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
) => {
    return [
        `/jobs/${jobUuid}/instants/${dateRange}`,
        ...(params ? [params] : []),
    ] as const
}

export const getGetRequestJobsInstantsByJobUuidAndDateRangeQueryOptions = <
    TData = Awaited<
        ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    dateRange: string,
    params: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsInstantsByJobUuidAndDateRange
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ??
        getGetRequestJobsInstantsByJobUuidAndDateRangeQueryKey(
            jobUuid,
            dateRange,
            params,
        )

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>>
    > = ({ signal }) =>
        getRequestJobsInstantsByJobUuidAndDateRange(
            jobUuid,
            dateRange,
            params,
            requestOptions,
            signal,
        )

    return {
        queryKey,
        queryFn,
        enabled: !!(jobUuid && dateRange),
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsInstantsByJobUuidAndDateRangeQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>>
    >
export type GetRequestJobsInstantsByJobUuidAndDateRangeQueryError =
    ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsInstantsByJobUuidAndDateRange<
    TData = Awaited<
        ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    dateRange: string,
    params: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsInstantsByJobUuidAndDateRange
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsInstantsByJobUuidAndDateRange
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsInstantsByJobUuidAndDateRange
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsInstantsByJobUuidAndDateRange<
    TData = Awaited<
        ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    dateRange: string,
    params: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsInstantsByJobUuidAndDateRange
                    >
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsInstantsByJobUuidAndDateRange
                        >
                    >,
                    TError,
                    Awaited<
                        ReturnType<
                            typeof getRequestJobsInstantsByJobUuidAndDateRange
                        >
                    >
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestJobsInstantsByJobUuidAndDateRange<
    TData = Awaited<
        ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    dateRange: string,
    params: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsInstantsByJobUuidAndDateRange
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Instant By Date
 */

export function useGetRequestJobsInstantsByJobUuidAndDateRange<
    TData = Awaited<
        ReturnType<typeof getRequestJobsInstantsByJobUuidAndDateRange>
    >,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    dateRange: string,
    params: GetRequestJobsInstantsByJobUuidAndDateRangeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<
                        typeof getRequestJobsInstantsByJobUuidAndDateRange
                    >
                >,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions =
        getGetRequestJobsInstantsByJobUuidAndDateRangeQueryOptions(
            jobUuid,
            dateRange,
            params,
            options,
        )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
